import React from 'react';
import { Icon, Popover, Popconfirm, Card } from 'antd';
import SERVER_URL from '../Global';
import { Link } from 'react-router-dom';
import htmlToImage from 'html-to-image';

const _ = require('underscore');

class CardDetailed extends React.Component {
    constructor(props) {
        super(props);
        var categories = []

        let blockFooter = this.props.blockFooter != null ? true : false
        this.props.company.companyCategories.map(cat =>
            categories.push(cat.catId)
        )

        this.state = {
            comp: this.props.company,
            user: this.props.token,
            categories: categories,
            modalDelete: false,
            blockFooter: blockFooter,
            brands:"",
        };

        this.showOfficeDetail = this.showOfficeDetail.bind(this);
        this.revertComp = this.revertComp.bind(this);
    }

    downloadImage() {
    htmlToImage.toJpeg(document.getElementsByClassName('ant-modal-content')[0], { quality: 0.95, width: 520 })
        .then(function (dataUrl) {
            var name = document.getElementsByClassName('ant-modal-title')[0].textContent
            var link = document.createElement('a');
            link.download = `${name}.jpeg`;
            link.href = dataUrl;
            link.click();
        });
    }


    componentDidUpdate(prevProps) {
        if (this.props.company !== prevProps.company) {
            this.setState({ comp: this.props.company });
        }
    }

    showSons = (company, firstSon) => {
        let categories = <h4 className="categoryNameList">
            {
                company.companyCategories.map(cat => {
                    if (this.state.categories.indexOf(cat.catId) == -1) {
                        return <span key={cat.catId}> {cat.name}</span>
                    }
                })
            }
        </h4>

        //COMPANIES

        let companyList = []

        company.companySons.map(son => {
            if (son != null) {
                if (son.companyTypologyTrValue === 1) {
                    companyList.push(son)
                }
            }
        })

        companyList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })

        let companyOwned = companyList.length != 0 ? <div style={{ width: '100%', textAlign: 'center' }}>
            <span>Società del gruppo:&nbsp;
                    <ul className="listOfBrands">
                    {companyList.map(son => {
                        let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                        let abroadCategories = son.brCompanyCategories[0].catId != company.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                        return (<li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>)
                    }
                    )}
                </ul>
            </span>
        </div> : ''

        //BRANDS

        let brandList = []

        company.companySons.map(son => {
            if (son != null) {
                if (son.companyTypologyTrValue === 2) {
                    brandList.push(son)
                }
            }
        })
        brandList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })
        let brandOwned = brandList.map(son => {
            let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
            let abroadCategories = son.brCompanyCategories[0].catId != company.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
            return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
        })

        let brandOwnedLabel = brandOwned.length == 1 ? "Marchio:" : "Marchi:"
        let brandOwnedFinal = brandOwned.length > 0 ? <ul className="listOfBrands">{brandOwnedLabel} {brandOwned}</ul> : null

        //ProducedByME

        let brandProducedList = company.companyProducedByMe.map(son => {
            if (son.companyTypologyTrValue === 2 && son.companyProducerCompanyId != son.companyParentCompanyId) {
                let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                let abroadCategories = son.brCompanyCategories[0].catId != company.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
            }
        })
        brandProducedList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })
        let brandCounterProduced = []

        brandProducedList.map(el => {
            if (el != undefined) {
                brandCounterProduced.push(el)
            }
        })

        let brandProducedLabel = brandCounterProduced.length === 0 ? "" : brandCounterProduced.length === 1 ? "Marchio prodotto:" : "Marchi prodotti:"

        let brandCompanyProduced = company.companyProducedByMe.length > 0 ? <ul className="listOfBrands">{brandProducedLabel} {brandProducedList}</ul> : ""

        //DistributedByME
        company.companyDistributedByMe.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })

        let brandDistributedList = company.companyDistributedByMe.map(son => {
            if (son.companyTypologyTrValue === 2 && son.companyDistributorCompanyId != son.companyParentCompanyId) {
                let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                let abroadCategories = son.brCompanyCategories[0].catId != company.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
            }
        })

        let brandCounterDistributed = []

        brandDistributedList.map(el => {
            if (el != undefined) {
                brandCounterDistributed.push(el)
            }
        })

        let brandDistributedLabel = brandCounterDistributed.length === 0 ? "" : brandCounterDistributed.length === 1 ? "Marchio distribuito:" : "Marchi distribuiti:"

        let brandCompanyDistributed = company.companyDistributedByMe.length > 0 ? <ul className="listOfBrands">{brandDistributedLabel} {brandDistributedList}</ul> : ""

        //LicensedByME

        let brandLicensedList = company.companyLicensedByMe.map(son => {
            if (son.companyTypologyTrValue === 2 && son.companyLicenserCompanyId != son.companyParentCompanyId) {
                let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                let abroadCategories = son.brCompanyCategories[0].catId != company.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
            }
        })
        brandLicensedList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })
        let brandCounterLicensed = []

        brandLicensedList.map(el => {
            if (el != undefined) {
                brandCounterLicensed.push(el)
            }
        })

        let brandLicensedLabel = brandCounterLicensed.length === 0 ? "" : brandCounterLicensed.length === 1 ? "Marchio in licenza:" : "Marchi in licenza:"

        let brandCompanyLicensed = company.companyLicensedByMe.length > 0 ? <ul className="listOfBrands">{brandLicensedLabel} {brandLicensedList}</ul> : ""

        //SIGNS

        let signList = []

        company.companySons.map(son => {
            if (son != null) {
                if (son.companyTypologyTrValue === 17) {
                    signList.push(son)
                }
            }
        })
        signList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })
        let signOwned = signList.map(son => {
            let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
            let abroadCategories = son.brCompanyCategories[0].catId != company.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
            return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
        })

        let signOwnedLabel = signOwned.length == 1 ? "Insegna:" : "Insegne:"
        let signOwnedFinal = signOwned.length > 0 ? <ul className="listOfBrands">{signOwnedLabel} {signOwned}</ul> : null

        //ProducedByME

        let signProducedList = company.companyProducedByMe.map(son => {
            if (son.companyTypologyTrValue === 17 && son.companyProducerCompanyId != son.companyParentCompanyId) {
                let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                let abroadCategories = son.brCompanyCategories[0].catId != company.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
            }
        })
        signProducedList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })
        let signCounterProduced = []

        signProducedList.map(el => {
            if (el != undefined) {
                signCounterProduced.push(el)
            }
        })

        let signProducedLabel = signCounterProduced.length === 0 ? "" : signCounterProduced.length === 1 ? "Insegna prodotta:" : "Insegne prodotte:"

        let signCompanyProduced = company.companyProducedByMe.length > 0 ? <ul className="listOfBrands">{signProducedLabel} {signProducedList}</ul> : ""

        //DistributedByME

        let signDistributedList = company.companyDistributedByMe.map(son => {
            if (son.companyTypologyTrValue === 17 && son.companyDistributorCompanyId != son.companyParentCompanyId) {
                let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                let abroadCategories = son.brCompanyCategories[0].catId != company.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
            }
        })
        signDistributedList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })
        let signCounterDistributed = []

        signDistributedList.map(el => {
            if (el != undefined) {
                signCounterDistributed.push(el)
            }
        })

        let signDistributedLabel = signCounterDistributed.length === 0 ? "" : signCounterDistributed.length === 1 ? "Insegna distribuita:" : "Insegne distribuite:"

        let signCompanyDistributed = company.companyDistributedByMe.length > 0 ? <ul className="listOfBrands">{signDistributedLabel} {signDistributedList}</ul> : ""

        //LicensedByME

        let signLicensedList = company.companyLicensedByMe.map(son => {
            if (son.companyTypologyTrValue === 17 && son.companyLicenserCompanyId != son.companyParentCompanyId) {

                let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                let abroadCategories = son.brCompanyCategories[0].catId != company.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
            }
        })
        signLicensedList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })
        let signCounterLicensed = []

        signLicensedList.map(el => {
            if (el != undefined) {
                signCounterLicensed.push(el)
            }
        })

        let signLicensedLabel = signCounterLicensed.length === 0 ? "" : signCounterLicensed.length === 1 ? "Insegna in licenza:" : "Insegne in licenza:"

        let signCompanyLicensed = company.companyLicensedByMe.length > 0 ? <ul className="listOfSigns">{signLicensedLabel} {signLicensedList}</ul> : ""

        //BRANDS DISTRIBUTED BY OTHERS

        let brandDistrConst = 0

        let brandDistributedByOthers = company.companySons.map(son => {
            if (son != null) {
                if (son.companyDistributor != null && son.companyDistributor.companyId != son.companyParent.companyId) {
                    if (son.companyTypologyTrValue === 2) {
                        brandDistrConst++
                        let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                        let abroadCategories = son.brCompanyCategories[0].catId != company.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                        return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name}</span> è distribuito da <span className={fakeLink} onClick={() => this.props.getDetail(son.companyDistributor.companyId, true)}>{son.companyDistributor.name}</span></li>
                    }
                }
            }
        })

        //BRANDS PRODUCED BY OTHERS

        let brandProdConst = 0

        let brandProducedByOthers = company.companySons.map(son => {
            if (son != null) {
                if (son.companyProducer != null && son.companyProducer.companyId != son.companyParent.companyId) {
                    if (son.companyTypologyTrValue === 2) {
                        brandProdConst++
                        let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                        let abroadCategories = son.brCompanyCategories[0].catId != company.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                        return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name}</span> è prodotto da <span className={fakeLink} onClick={() => this.props.getDetail(son.companyProducer.companyId, true)}>{son.companyProducer.name}</span></li>
                    }
                }
            }
        })

        //SIGNS DISTRIBUTED BY OTHERS

        let signDistrConst = 0

        let signDistributedByOthers = company.companySons.map(son => {
            if (son != null) {
                if (son.companyDistributor != null && son.companyDistributor.companyId != son.companyParent.companyId) {
                    if (son.companyTypologyTrValue === 17) {
                        signDistrConst++
                        let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                        let abroadCategories = son.brCompanyCategories[0].catId != company.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                        return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name}</span> è distribuito da <span className={fakeLink} onClick={() => this.props.getDetail(son.companyDistributor.companyId, true)}>{son.companyDistributor.name}</span></li>
                    }
                }
            }
        })

        //SIGNS PRODUCED BY OTHERS

        let signProdConst = 0

        let signProducedByOthers = company.companySons.map(son => {
            if (son != null) {
                if (son.companyProducer != null && son.companyProducer.companyId != son.companyParent.companyId) {
                    if (son.companyTypologyTrValue === 17) {
                        signProdConst++
                        let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                        let abroadCategories = son.brCompanyCategories[0].catId != company.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                        return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name}</span> è prodotto da <span className={fakeLink} onClick={() => this.props.getDetail(son.companyProducer.companyId, true)}>{son.companyProducer.name}</span></li>
                    }
                }
            }
        })

        let ProducedByOthersFinal = signProdConst > 0 ? <ul className="listOfBrands">Vedi: {brandDistributedByOthers} {brandProducedByOthers} {signDistributedByOthers} {signProducedByOthers}</ul> : null


        //END

        let referenceList = company.companyLinks.length > 0 ?
            <p className="referenceList">
                <span>Vedi: </span>
                {company.companyLinks.map((link, i) => {
                    let categories = link.companyLinkTo.brCompanyCategories.map(cat => {
                        if (cat.catId != company.brCompanyCategories[0].catId) {

                            let parentCat = cat.companyCategories.companyCategoryParent != null ? cat.companyCategories.companyCategoryParent.name + ", " : null
                            return <span className="catLink" key={cat.catId}>({parentCat}{cat.companyCategories.name})</span>
                        }
                    })

                    let num = i + 1;
                    let name = num == company.companyLinks.length ? link.companyLinkTo.name : link.companyLinkTo.name + ", "
                    let fakeLink = link.companyLinkTo.status == 0 ? 'hiddenLink' : 'fakeLink'

                    return (
                        <span key={link.companyLinkToCompanyId}>
                            {categories}
                            <Link to="#" style={{ display: 'inline', paddingBottom: '1em' }} onClick={() => this.props.getDetail(link.companyLinkToCompanyId, true)}>
                                <b className={fakeLink}>{name}</b>
                            </Link>
                        </span>
                    )
                })
                }
            </p> : ''

        if (company.status == 4 || company.status == 3) {
            // Questo if else serve a mostrare le aziende figlie delle aziende "alone" solo dentro la scheda del genitore di primo livello
            if (company.status == 3 && company.companyParent.status == 1 && firstSon == false) {

            } else {
                return (
                    <div key={company.companyId}>
                        <hr style={{ borderColor: "#000", marginTop: '15px', marginBottom: '15px' }} />
                        <h3 className="departmentName">{company.name}</h3>
                        <h4 className="companyTypology">{company.companyTypology.text}</h4>
                        {categories}
                        {companyOwned}
                        {brandOwnedFinal}
                        {signOwnedFinal}
                        {ProducedByOthersFinal}
                        {brandCompanyProduced}
                        {brandCompanyDistributed}
                        {brandCompanyLicensed}
                        {signCompanyProduced}
                        {signCompanyDistributed}
                        {signCompanyLicensed}                        
                        <p>{company.description}</p>
                        <div className="hrOffice">
                            <ul>
                                {company.offices.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(o => {
                                    return this.showOfficeDetail(o)
                                })}
                            </ul>
                        </div>
                        {referenceList}
                        <p>{company.footer}</p>
                        {company.companySons.map(son => {
                            if (son != null) {
                                return this.showSons(son, false)
                            }
                        })}
                    </div>
                )
            }
        } else if (company.companySons.length != 0 && company.status != 2) {
            return (
                company.companySons.map(son => {
                    if (son != null) {
                        return this.showSons(son, false)
                    }
                })
            )
        }
    }

    revertComp() {
        fetch(
            `${SERVER_URL + "api/company/restore/" + this.state.comp.companyId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
            }
        ).then(response => response.json())
        .then(res => {
            this.props.crossFetch(this.state.comp.companyId);
        })
    }

    showOfficeDetail(o) {

        let officeName = o.isPrincipal || o.name === "" ? '' : <div><h3 className="officeName" >{o.name}</h3><h4 className="companyTypology">Office</h4> </div>

        let vari = []

        let officeAddresses = o.addresses != null ? o.addresses.map(add => {
            let street = add.street.length > 3 ? add.street + " -" : ''
            if (add.city.province.region.nation != null) {
                if (add.city.province.region.nation.name == "Italia") {
                    return <p key={add.addressId} >{street} {add.zipCode.value} {add.city.name} ({add.city.province.initials}) {/*add.city.province.region.name*/}</p>
                } else {
                    return <p key={add.addressId} >{street} {add.zipCode.value} {add.city.name} ({add.city.province.region.nation.name}) {/*add.city.province.region.name*/}</p>
                }
            }
        }) : ''

        const indirizzoIcon = () => (
            <svg aria-hidden="true" height="1em" focusable="false" data-prefix="fas" data-icon="map-marker-alt" className="svg-inline--fa fa-map-marker-alt fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"></path></svg>
        )

        const telefonoIcon = () => (
            <svg xmlns="http://www.w3.org/2000/svg" className="svg-inline--fa fa-phone fa-w-16" height="1em" role="img" aria-hidden="true" viewBox="0 0 512 512" focusable="false" data-icon="phone" data-prefix="fas"><path fill="currentColor" d="M 493.4 24.6 l -104 -24 c -11.3 -2.6 -22.9 3.3 -27.5 13.9 l -48 112 c -4.2 9.8 -1.4 21.3 6.9 28 l 60.6 49.6 c -36 76.7 -98.9 140.5 -177.2 177.2 l -49.6 -60.6 c -6.8 -8.3 -18.2 -11.1 -28 -6.9 l -112 48 C 3.9 366.5 -2 378.1 0.6 389.4 l 24 104 C 27.1 504.2 36.7 512 48 512 c 256.1 0 464 -207.5 464 -464 c 0 -11.2 -7.7 -20.9 -18.6 -23.4 Z" /></svg>
        )

        const cellularIcon = () => (
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" height="1em" focusable="false" data-prefix="fas" data-icon="mobile-alt" className="svg-inline--fa fa-mobile-alt fa-w-10" role="img" viewBox="0 0 320 512" > <path fill="currentColor" d="M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z" /></svg>
        )

        const faxIcon = () => (
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" height="1em" focusable="false" data-prefix="fas" data-icon="print" className="svg-inline--fa fa-print fa-w-16" role="img" viewBox="0 0 512 512"><path fill="currentColor" d="M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z" /></svg>
        )

        const websiteIcon = () => (
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" height="1em" focusable="false" data-prefix="fas" data-icon="globe" className="svg-inline--fa fa-globe fa-w-16" role="img" viewBox="0 0 496 512"><path fill="currentColor" d="M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z" /></svg>
        )

        const mailIcon = () => (
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" height="1em" focusable="false" data-prefix="fas" data-icon="envelope" className="svg-inline--fa fa-envelope fa-w-16" role="img" viewBox="0 0 512 512"><path fill="currentColor" d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z" /></svg>
        )

        const fbIcon = () => (
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" height="1em" focusable="false" data-prefix="fab" data-icon="facebook" className="svg-inline--fa fa-facebook fa-w-16" role="img" viewBox="0 0 512 512"><path fill="currentColor" d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" /></svg>
        )

        const instagramIcon = () => (
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" height="1em" focusable="false" data-prefix="fab" data-icon="instagram" className="svg-inline--fa fa-instagram fa-w-14" role="img" viewBox="0 0 448 512"><path fill="currentColor" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" /></svg>
        )

        const linkedinIcon = () => (
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" height="1em" focusable="false" data-prefix="fab" data-icon="linkedin" className="svg-inline--fa fa-linkedin fa-w-14" role="img" viewBox="0 0 448 512"><path fill="currentColor" d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" /></svg>
        )

        const twitterIcon = () => (
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" height="1em" focusable="false" data-prefix="fab" data-icon="twitter" className="svg-inline--fa fa-x-twitter fa-w-16" role="img" viewBox="0 0 512 512"><path fill="currentColor" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z " /></svg> 
        )

        const youtubeIcon = () => (
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" height="1em" focusable="false" data-prefix="fab" data-icon="youtube" className="svg-inline--fa fa-youtube fa-w-18" role="img" viewBox="0 0 576 512"><path fill="currentColor" d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" /></svg>    
        )

        let groupRole = []

        o.brHrRoleOfficies.map(br => {
            let ok = true

            groupRole.map(gr => {
                if (br.roleId == gr.id) {
                    ok = false
                }
            })

            if (ok && br.role != null) {
                groupRole.push({ id: br.roleId, name: br.role.name, sort: br.role.sort })
            }
        })

        if (groupRole.length == 0) {
            groupRole.push("ufficio")
        }

        return (
            <div key={o.officeId}>
                {officeName}
                <p>{o.Notes}</p>
                {officeAddresses}
                <ul className="listContacts">

                    {o.brHrRoleOfficies.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).filter(br => br.roleId == null).map(bridge => {

                        var groupContacts = _.groupBy(bridge.brHrRoleOfficeContacts, function (brCon) { return brCon.contact.propertyTr.queryTip });                        

                        let indirizzo = bridge.showAddressWorkingFor && bridge.workingFor != null ?
                            bridge.workingFor.office.addresses.map(add => {
                                let text = add.street + ", " + add.zipCode.value + ", " + add.city.name + " (" + add.city.province.initials + ")"

                                return (<li key={add.addressId}> <Icon component={indirizzoIcon} /> {text}</li>)
                            }) : ''

                        let telefono = typeof groupContacts.telefono !== 'undefined' ? groupContacts.telefono.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                            return (<li key={con.contactId}> <Icon component={telefonoIcon} /> {con.contact.text}</li>)
                        }) : ''

                        let cellulare = typeof groupContacts.cellulare !== 'undefined' ? groupContacts.cellulare.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                            return (<li key={con.contactId}><Icon component={cellularIcon} /> {con.contact.text}</li>)
                        }) : ''

                        let fax = typeof groupContacts.fax !== 'undefined' ? groupContacts.fax.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                            return (<li key={con.contactId}><Icon component={faxIcon} /> {con.contact.text}</li>)
                        }) : ''

                        let numeroverde = typeof groupContacts.numeroverde !== 'undefined' ? groupContacts.numeroverde.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                            return (<li key={con.contactId}> <Icon style={{ color: 'green' }} component={telefonoIcon} /> {con.contact.text}</li>)
                        }) : ''

                        let website = typeof groupContacts.website !== 'undefined' ? groupContacts.website.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                            let webSiteUrl = con.contact.text
                            let webSiteUrlComplete = webSiteUrl.includes('http') ? webSiteUrl : "http://" + webSiteUrl
                            let webSiteUrlVisual = webSiteUrl.includes('https') ? webSiteUrl.substr(8) : webSiteUrl.includes('http') ? webSiteUrl.substr(7) : webSiteUrl
                            return (<li key={con.contactId} ><Link to={webSiteUrlComplete} target="_blank"><Icon component={websiteIcon} /> {webSiteUrlVisual}</Link></li>)
                        }) : ''

                        let mail = typeof groupContacts.mail !== 'undefined' ? groupContacts.mail.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                            return (<li key={con.contactId} ><Link to={"mailto:" + con.contact.text} target="_blank"><Icon component={mailIcon} /> {con.contact.text}</Link></li>)
                        }) : ''

                        let pec = typeof groupContacts.pec !== 'undefined' ? groupContacts.pec.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                            return (<li key={con.contactId} ><Link to={"mailto:" + con.contact.text} target="_blank"><span>PEC:</span> {con.contact.text}</Link></li>)
                        }) : ''

                        let facebook = typeof groupContacts.facebook !== 'undefined' ? groupContacts.facebook.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                            return (<li key={con.contactId} ><Icon component={fbIcon} /> {con.contact.text}</li>)
                        }) : ''

                        let instagram = typeof groupContacts.instagram !== 'undefined' ? groupContacts.instagram.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                            return (<li key={con.contactId} ><Icon component={instagramIcon} /> {con.contact.text}</li>)
                        }) : ''

                        let linkedin = typeof groupContacts.linkedin !== 'undefined' ? groupContacts.linkedin.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                            return (<li key={con.contactId} ><Icon component={linkedinIcon} /> {con.contact.text}</li>)
                        }) : ''

                        let twitter = typeof groupContacts.twitter !== 'undefined' ? groupContacts.twitter.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                            return (<li key={con.contactId} ><Icon component={twitterIcon} /> {con.contact.text}</li>)
                        }) : ''

                        let youtube = typeof groupContacts.youtube !== 'undefined' ? groupContacts.youtube.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                            return (<li key={con.contactId} ><Icon component={youtubeIcon} /> {con.contact.text}</li>)
                        }) : ''

                        let showContacts = <ul style={{ display: 'contents' }}>
                            {indirizzo}

                            {telefono}

                            {cellulare}

                            {fax}

                            {numeroverde}

                            {website}

                            {mail}

                            {pec}

                            {facebook}

                            {instagram}

                            {linkedin}

                            {twitter}

                            {youtube}
                        </ul>

                        return (
                            <li className="listRoles" style={{ order: `${bridge.sort}` }} key={bridge.hroId}>
                                {showContacts}
                            </li>
                            )
                        })
                    }

                    {groupRole.map((gr,i) => {

                        return (
                            <li className="listRoles" style={{ order: `${gr.sort}` }} key={i}>

                                <ul>

                                    {o.brHrRoleOfficies.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).filter(br => br.roleId == gr.id).map(bridge => {

                                        if (bridge.workingFor != null) {
                                        if (bridge.workingFor.officeId == o.officeId) {
                                            bridge.workingFor.office = o
                                        }
                                    }

                                    var groupContacts = _.groupBy(bridge.brHrRoleOfficeContacts, function (brCon) { return brCon.contact.propertyTr.queryTip });

                                    console.log(bridge);

                                        let indirizzo = bridge.showAddressWorkingFor && bridge.workingFor != null ?
                                    bridge.workingFor.office.addresses.map(add => {
                                            let text = add.street + ", " + add.zipCode.value + ", " + add.city.name + " (" + add.city.province.initials + ")"

                                            return (<li key={add.addressId}> <Icon component={indirizzoIcon} /> {text}</li>)
                                    }) : ''
                        
                                    let telefono = typeof groupContacts.telefono !== 'undefined' ? groupContacts.telefono.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                                        return (<li key={con.contactId}> <Icon component={telefonoIcon} /> {con.contact.text}</li>)
                                    }) : ''

                                    let cellulare = typeof groupContacts.cellulare !== 'undefined' ? groupContacts.cellulare.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                                        return (<li key={con.contactId}><Icon component={cellularIcon} /> {con.contact.text}</li>)
                                    }) : ''

                                    let fax = typeof groupContacts.fax !== 'undefined' ? groupContacts.fax.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                                        return (<li key={con.contactId}><Icon component={faxIcon} /> {con.contact.text}</li>)
                                    }) : ''

                                    let numeroverde = typeof groupContacts.numeroverde !== 'undefined' ? groupContacts.numeroverde.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                                        return (<li key={con.contactId}> <Icon style={{color: 'green'}} component={telefonoIcon}/> {con.contact.text}</li>)
                                    }) : ''

                                    let website = typeof groupContacts.website !== 'undefined' ? groupContacts.website.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                                        let webSiteUrl = con.contact.text
                                        let webSiteUrlComplete = webSiteUrl.includes('http') ? webSiteUrl : "http://" + webSiteUrl
                                        let webSiteUrlVisual = webSiteUrl.includes('https') ? webSiteUrl.substr(8) : webSiteUrl.includes('http') ? webSiteUrl.substr(7) : webSiteUrl
                                        return (<li key={con.contactId} ><Link to={webSiteUrlComplete} target="_blank"><Icon component={websiteIcon} /> {webSiteUrlVisual}</Link></li>)
                                    }) : ''

                                    let mail = typeof groupContacts.mail !== 'undefined' ? groupContacts.mail.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                                        return (<li key={con.contactId} ><Link to={"mailto:" + con.contact.text} target="_blank"><Icon component={mailIcon} /> {con.contact.text}</Link></li>)
                                    }) : ''

                                    let pec = typeof groupContacts.pec !== 'undefined' ? groupContacts.pec.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                                        return (<li key={con.contactId} ><Link to={"mailto:" + con.contact.text} target="_blank"><span>PEC:</span> {con.contact.text}</Link></li>)
                                    }) : ''

                                    let facebook = typeof groupContacts.facebook !== 'undefined' ? groupContacts.facebook.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                                        return (<li key={con.contactId} ><Icon component={fbIcon} /> {con.contact.text}</li>)
                                    }) : ''

                                    let instagram = typeof groupContacts.instagram !== 'undefined' ? groupContacts.instagram.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                                        return (<li key={con.contactId} ><Icon component={instagramIcon} /> {con.contact.text}</li>)
                                    }) : ''

                                    let linkedin = typeof groupContacts.linkedin !== 'undefined' ? groupContacts.linkedin.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                                        return (<li key={con.contactId} ><Icon component={linkedinIcon} /> {con.contact.text}</li>)
                                    }) : ''

                                    let twitter = typeof groupContacts.twitter !== 'undefined' ? groupContacts.twitter.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                                        return (<li key={con.contactId} ><Icon component={twitterIcon} /> {con.contact.text}</li>)
                                    }) : ''

                                    let youtube = typeof groupContacts.youtube !== 'undefined' ? groupContacts.youtube.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(con => {
                                        return (<li key={con.contactId} ><Icon component={youtubeIcon} /> {con.contact.text}</li>)
                                    }) : ''

                                    let showContacts = <ul style={{ display: 'contents' }}>
                                        {indirizzo}

                                        {telefono}

                                        {cellulare}

                                        {fax}

                                        {numeroverde}

                                        {website}

                                        {mail}

                                        {pec}

                                        {facebook}

                                        {instagram}

                                        {linkedin}

                                        {twitter}

                                        {youtube}
                                        </ul>

                                        if (bridge.hr != null && bridge.role != null) {
                                            if (!vari.includes(bridge.role.roleId)) {
                                                vari.push(bridge.role.roleId)
                                                let hasInterim = bridge.isAdInterim !== true ? "" : " (Ad Interim)"
                                                let hasCollab = bridge.workingForHROId !== null ? <span key={bridge.hroId}><p><b>{bridge.role.name}: <span onClick={() => this.props.getDetail(bridge.workingFor.office.companyId, true)} className={bridge.workingFor.office.company.status == 0 ? 'hiddenLink' : 'fakeLink'}> {bridge.workingFor.office.company.name}</span> </b>{bridge.hr.fullName}{hasInterim}</p></span>
                                                    : <span key={bridge.hroId}><p><b>{bridge.role.name}: </b><span className="titleScheda">{bridge.title}</span></p><p> {bridge.hr.fullName}{hasInterim}</p></span>

                                                return (
                                                    <li className="listContacts" style={{ order: `${bridge.sort}` }} key={bridge.hroId}>
                                                        {hasCollab}
                                                        {showContacts}
                                                    </li>
                                                )
                                            } else {
                                                let hasInterim = bridge.isAdInterim !== true ? "" : " (Ad Interim)"
                                                return (
                                                    <li className="listContacts" style={{ order: `${bridge.sort}` }} key={bridge.hroId}>
                                                        <p key={bridge.hroId}>{bridge.title} {bridge.hr.fullName}{hasInterim}</p>
                                                        {showContacts}
                                                    </li>
                                                )
                                            }
                                        } else if (bridge.hr == null && bridge.role != null) {

                                            if (bridge.workingFor != null) {
                                                if (bridge.workingFor.officeId == o.officeId) {
                                                    bridge.workingFor.office = o
                                                }
                                            }

                                            let hasCollab = bridge.workingFor !== null ? <span key={bridge.hroId}><p><b>{bridge.role.name}: <span onClick={() => this.props.getDetail(bridge.workingFor.office.companyId, true)} className={bridge.workingFor.office.company.status == 0 ? 'hiddenLink' : 'fakeLink'}> {bridge.workingFor.office.company.name}</span> </b></p></span>
                                                : <span key={bridge.hroId}><p><b>{bridge.role.name}:</b> {bridge.title}</p></span>

                                            let roleName = !vari.includes(bridge.role.roleId) ? hasCollab : ''

                                            if (!vari.includes(bridge.role.roleId)) {
                                                vari.push(bridge.role.roleId)
                                            }

                                            return (
                                                <li className="listContacts" style={{ order: `${bridge.sort}` }} key={bridge.hroId}>
                                                    {roleName}
                                                    {showContacts}
                                                </li>
                                            )
                                        }
                                })
                                }
                            </ul>
                        </li>
                        )}
                    )}
                </ul>
            </div>
        )
    }

    deleteComp(id, definitive) {
        if (definitive == 1) {
            //eliminazione soft
            fetch(
                `${SERVER_URL + 'api/company/' + id}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    }
                }
            ).then(() => {
                this.setState({ modalDelete: false })
                this.props.crossFetch(id);
            })
        }
        else {
            //eliminazione hard
            fetch(
                `${SERVER_URL + 'api/company/hard/' + id}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    }
                }
            ).then(() => {
                this.setState({ modalDelete: false })
                this.props.crossFetch(id);
            })
        }
    }

    render() {
        let comp = this.state.comp
        let image = ''
                var checkImage = true;
        if (!comp.companyImage || comp.companyImage == null || comp.companyImage == 'null') {
            var iniziale = comp.name.charAt(0);
            var checkImage = false;
        } else {
            image = 'data:' + comp.imageType + ';base64,' + comp.companyImage
        }
        let vari = []

        let referenceList = comp.companyLinks.length > 0 ?
            <p className="referenceList">
                <span>Vedi: </span>
                {comp.companyLinks.map((link, i) => {
                    let categories = link.companyLinkTo.brCompanyCategories.map(cat => {
                        if (cat.catId != comp.brCompanyCategories[0].catId) {
                            
                            let parentCat = cat.companyCategories.companyCategoryParent != null ? cat.companyCategories.companyCategoryParent.name + ", " : null 
                            return <span className="catLink" key={cat.catId}>({parentCat}{cat.companyCategories.name})</span>
                        }
                    })

                    let num = i + 1;
                    let name = num == comp.companyLinks.length ? link.companyLinkTo.name : link.companyLinkTo.name + ", "
                    let fakeLink = link.companyLinkTo.status == 0 ? 'hiddenLink' : 'fakeLink'

                    return (
                        <span key={link.companyLinkToCompanyId}>
                            {categories}
                            <Link to="#" style={{ display: 'inline', paddingBottom: '1em' }} onClick={() => this.props.getDetail(link.companyLinkToCompanyId, true)}>
                                <b className={fakeLink}>{name}</b>
                            </Link>
                        </span>
                    )
                })
                }
            </p> : ''

        let isThereAFooter = comp.footer == null ?
            null : comp.footer.length > 1 ?
                <div>
                    <hr style={{ borderColor: "#000", marginTop:'0.7em', marginBottom:'0.7em' }} />
                    <p style={{ marginBottom: '0.7em' }}>{comp.footer}</p>
                </div> : null

        let dadOrSon = 
        <div className="officeInfo" >
            <div className="dataOffice">
                {comp.offices.sort(({ sort: previousID }, { sort: currentID }) => previousID - currentID).map(o => {
                    return this.showOfficeDetail(o)
                })}
            </div>
                {comp.companySons.map(nip => {
                    if (nip != null) {
                        return this.showSons(nip)
                    }
                }
            )}
                        
            {this.emptyRoleId}

            {isThereAFooter}
        </div>

        let immagine = checkImage ? <div style={{ backgroundImage: 'url(' + `${image}` + ')' }} className="trueImage"></div> : <div className="fakeImage">{iniziale}</div>;

        let pIva = comp.pIva ? <p>Partita Iva: {comp.pIva}</p> : ''

        let description = <p>{comp.description}</p>;

        var sorted_cat = comp.brCompanyCategories.sort((a, b) => {
            return new Date(a.created).getTime() -
                new Date(b.created).getTime()
        })

        let category =
            <div>
                {referenceList}

                <h4 className="categoryNameList">
                {
                        sorted_cat.map(cat => {
                            let parentCat = cat.companyCategories.companyCategoryParent != null ? cat.companyCategories.companyCategoryParent.name + " - " : null
                            return <span key={cat.catId}><i>{parentCat}</i>{cat.companyCategories.name}</span>
                        }
                    )
                }
                </h4>
            </div>

        //COMPANIES

        let companyList = []

        comp.companySons.map(son => {
            if (son != null) {
                if (son.companyTypologyTrValue === 1) {
                    companyList.push(son)
                }
            }
        })

        companyList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })

        let companyOwned = companyList.length != 0 ? <div style={{ width: '100%', textAlign: 'center' }}>
            <span>Società del gruppo:&nbsp;
                    <ul className="listOfBrands">
                        {companyList.map(son => {
                            let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                            let abroadCategories = son.brCompanyCategories[0].catId != comp.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                            return (<li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>)
                        }
                        )}
                    </ul>
            </span>
        </div> : ''

        //BRANDS

        let brandList = []

        comp.companySons.map(son => {
            if (son != null) {
                if (son.companyTypologyTrValue === 2) {
                    brandList.push(son)
                }
            }
        })
        brandList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })
        let brandOwned = brandList.map(son => {
            let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
            let abroadCategories = son.brCompanyCategories[0].catId != comp.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
            return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
        })

        let brandOwnedLabel = brandOwned.length == 1 ? "Marchio:" : "Marchi:"
        let brandOwnedFinal = brandOwned.length > 0 ? <ul className="listOfBrands">{brandOwnedLabel} {brandOwned}</ul> : null

        //ProducedByME

        let brandProducedList = comp.companyProducedByMe.map(son => {
            if (son.companyTypologyTrValue === 2 && son.companyProducerCompanyId != son.companyParentCompanyId) {
                let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                let abroadCategories = son.brCompanyCategories[0].catId != comp.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
            }
        })

        let brandCounterProduced = []
        brandProducedList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })
        brandProducedList.map(el => {
            if (el != undefined) {
                brandCounterProduced.push(el)
            }
        })

        let brandProducedLabel = brandCounterProduced.length === 0 ? "" : brandCounterProduced.length === 1 ? "Marchio prodotto:" : "Marchi prodotti:"

        let brandCompanyProduced = comp.companyProducedByMe.length > 0 ? <ul className="listOfBrands">{brandProducedLabel} {brandProducedList}</ul> : ""

        //DistributedByME
        comp.companyDistributedByMe.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })

        let brandDistributedList = comp.companyDistributedByMe.map(son => {
            if (son.companyTypologyTrValue === 2 && son.companyDistributorCompanyId != son.companyParentCompanyId) {
                let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                let abroadCategories = son.brCompanyCategories[0].catId != comp.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
            }
        })

        let brandCounterDistributed = []

        brandDistributedList.map(el => {
            if (el != undefined) {
                brandCounterDistributed.push(el)
            }
        })


        let brandDistributedLabel = brandCounterDistributed.length === 0 ? "" : brandCounterDistributed.length === 1 ? "Marchio distribuito:" : "Marchi distribuiti:"

        let brandCompanyDistributed = comp.companyDistributedByMe.length > 0 ? <ul className="listOfBrands">{brandDistributedLabel} {brandDistributedList}</ul> : ""

        //LicensedByME

        comp.companyLicensedByMe.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })

        let brandLicensedList = comp.companyLicensedByMe.map(son => {
            if (son.companyTypologyTrValue === 2 && son.companyLicenserCompanyId != son.companyParentCompanyId) {
                let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                let abroadCategories = son.brCompanyCategories[0].catId != comp.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
            }
        })

        let brandCounterLicensed = []
        
        brandLicensedList.map(el => {
            if (el != undefined) {
                brandCounterLicensed.push(el)
            }
        })

        let brandLicensedLabel = brandCounterLicensed.length === 0 ? "" : brandCounterLicensed.length === 1 ? "Marchio in licenza:" : "Marchi in licenza:"

        let brandCompanyLicensed = comp.companyLicensedByMe.length > 0 ? <ul className="listOfBrands">{brandLicensedLabel} {brandLicensedList}</ul> : ""

        //SIGNS

        let signList = []

        comp.companySons.map(son => {
            if (son != null) {
                if (son.companyTypologyTrValue === 17) {
                    signList.push(son)
                }
            }
        })
        signList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })
        let signOwned = signList.map(son => {
            let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
            let abroadCategories = son.brCompanyCategories[0].catId != comp.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
            return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
        })

        let signOwnedLabel = signOwned.length == 1 ? "Insegna:" : "Insegne:"
        let signOwnedFinal = signOwned.length > 0 ? <ul className="listOfBrands">{signOwnedLabel} {signOwned}</ul> : null

        //ProducedByME

        let signProducedList = comp.companyProducedByMe.map(son => {
            if (son.companyTypologyTrValue === 17 && son.companyProducerCompanyId != son.companyParentCompanyId) {
                let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                let abroadCategories = son.brCompanyCategories[0].catId != comp.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
            }
        })
        signProducedList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })
        let signCounterProduced = []

        signProducedList.map(el => {
            if (el != undefined) {
                signCounterProduced.push(el)
            }
        })

        let signProducedLabel = signCounterProduced.length === 0 ? "" : signCounterProduced.length === 1 ? "Insegna prodotta:" : "Insegne prodotte:"

        let signCompanyProduced = comp.companyProducedByMe.length > 0 ? <ul className="listOfBrands">{signProducedLabel} {signProducedList}</ul> : ""

        //DistributedByME

        let signDistributedList = comp.companyDistributedByMe.map(son => {
            if (son.companyTypologyTrValue === 17 && son.companyDistributorCompanyId != son.companyParentCompanyId) {
                let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                let abroadCategories = son.brCompanyCategories[0].catId != comp.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
            }
        })
        signDistributedList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })
        let signCounterDistributed = []

        signDistributedList.map(el => {
            if (el != undefined) {
                signCounterDistributed.push(el)
            }
        })

        let signDistributedLabel = signCounterDistributed.length === 0 ? "" : signCounterDistributed.length === 1 ? "Insegna distribuita:" : "Insegne distribuite:"

        let signCompanyDistributed = comp.companyDistributedByMe.length > 0 ? <ul className="listOfBrands">{signDistributedLabel} {signDistributedList}</ul> : ""

        //LicensedByME

        let signLicensedList = comp.companyLicensedByMe.map(son => {
            if (son.companyTypologyTrValue === 17 && son.companyLicenserCompanyId != son.companyParentCompanyId) {

                let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                let abroadCategories = son.brCompanyCategories[0].catId != comp.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name} </span></li>
            }
        })
        signLicensedList.sort(function (a, b) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
            return 0;
        })
        let signCounterLicensed = []

        signLicensedList.map(el => {
            if (el != undefined) {
                signCounterLicensed.push(el)
            }
        })

        let signLicensedLabel = signCounterLicensed.length === 0 ? "" : signCounterLicensed.length === 1 ? "Insegna in licenza:" : "Insegne in licenza:"

        let signCompanyLicensed = comp.companyLicensedByMe.length > 0 ? <ul className="listOfSigns">{signLicensedLabel} {signLicensedList}</ul> : ""

        //BRANDS DISTRIBUTED BY OTHERS

        let brandDistrConst = 0

        let brandDistributedByOthers = comp.companySons.map(son => {
            if (son != null) {
                if (son.companyDistributor != null && son.companyDistributor.companyId != son.companyParent.companyId) {
                    if (son.companyTypologyTrValue === 2) {
                        brandDistrConst++
                        let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                        let abroadCategories = son.brCompanyCategories[0].catId != comp.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                        return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name}</span> è distribuito da <span className={fakeLink} onClick={() => this.props.getDetail(son.companyDistributor.companyId, true)}>{son.companyDistributor.name}</span></li>
                    }
                }
            }
        })

        //BRANDS PRODUCED BY OTHERS

        let brandProdConst = 0

        let brandProducedByOthers = comp.companySons.map(son => {
            if (son != null) {
                if (son.companyProducer != null && son.companyProducer.companyId != son.companyParent.companyId) {
                    if (son.companyTypologyTrValue === 2) {
                        brandProdConst++
                        let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                        let abroadCategories = son.brCompanyCategories[0].catId != comp.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                        return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name}</span> è prodotto da <span className={fakeLink} onClick={() => this.props.getDetail(son.companyProducer.companyId, true)}>{son.companyProducer.name}</span></li>
                    }
                }
            }
        })

        //SIGNS DISTRIBUTED BY OTHERS

        let signDistrConst = 0

        let signDistributedByOthers = comp.companySons.map(son => {
            if (son != null) {
                if (son.companyDistributor != null && son.companyDistributor.companyId != son.companyParent.companyId) {
                    if (son.companyTypologyTrValue === 17) {
                        signDistrConst++
                        let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                        let abroadCategories = son.brCompanyCategories[0].catId != comp.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                        return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name}</span> è distribuito da <span className={fakeLink} onClick={() => this.props.getDetail(son.companyDistributor.companyId, true)}>{son.companyDistributor.name}</span></li>
                    }
                }
            }
        })

        //SIGNS PRODUCED BY OTHERS

        let signProdConst = 0

        let signProducedByOthers = comp.companySons.map(son => {
            if (son != null) {
                if (son.companyProducer != null && son.companyProducer.companyId != son.companyParent.companyId) {
                    if (son.companyTypologyTrValue === 17) {
                        signProdConst++
                        let fakeLink = son.status == 0 ? 'hiddenLink' : 'fakeLink'
                        let abroadCategories = son.brCompanyCategories[0].catId != comp.brCompanyCategories[0].catId ? "(" + son.brCompanyCategories[0].companyCategories.name + ") - " : ''
                        return <li style={{ display: "inline" }} key={son.companyId}><span className={fakeLink} onClick={() => this.props.getDetail(son.companyId, true)}> {son.name}</span> è prodotto da <span className={fakeLink} onClick={() => this.props.getDetail(son.companyProducer.companyId, true)}>{son.companyProducer.name}</span></li>
                    }
                }
            }
        })

        let ProducedByOthersFinal = signProdConst > 0 ? <ul className="listOfBrands">Vedi: {brandDistributedByOthers} {brandProducedByOthers} {signDistributedByOthers} {signProducedByOthers}</ul> : null


        //END

        function addToBookmarks(blockFooter) {
            
            var bookmarked = JSON.parse("[" + localStorage.getItem("bookmarked") + "]");
            var id = comp.companyId

            if (bookmarked.includes(id)) {
                for (var i = 0; i < bookmarked.length; i++) {
                    if (bookmarked[i] === id) {
                        bookmarked.splice(i, 1);
                        localStorage.setItem('bookmarked', bookmarked);
                    }
                }
                document.getElementById("modalIcona" + id).childNodes[0].childNodes[0].style.fill = "grey";
                if (!blockFooter) {
                    document.getElementById("icona" + id).childNodes[0].childNodes[0].style.fill = "grey";
                }
            }
            else {
                bookmarked.push(id);
                localStorage.setItem('bookmarked', bookmarked);
                document.getElementById("modalIcona" + id).childNodes[0].childNodes[0].style.fill = "#ffa500";
                if (!blockFooter) {
                    document.getElementById("icona" + id).childNodes[0].childNodes[0].style.fill = "#ffa500";
                }
            }
        }

        if (localStorage.getItem("bookmarked") === null) {
            localStorage.setItem("bookmarked", [])
        }

        if (localStorage.getItem("bookmarked").indexOf(",") > -1) {
            var bookmarked = JSON.parse("[" + localStorage.getItem("bookmarked") + "]")
        }
        else if (localStorage.getItem("bookmarked") > 0) {
            var bookmarked = JSON.parse("[" + localStorage.getItem("bookmarked") + "]")
        }
        else {
            var bookmarked = []
        }

        let bookmark = bookmarked.includes(comp.companyId) ?
            <Popover content="Bookmark" trigger="hover">
                <Icon onClick={() => addToBookmarks(this.state.blockFooter)} id={"modalIcona" + comp.companyId} type="star" style={{ color: "#FFA500" }} className="bookmark actionIcon" />
            </Popover>
            :
            <a onClick={() => addToBookmarks(this.state.blockFooter)}>
                <Popover content="Bookmark" trigger="hover">
                    <Icon id={"modalIcona" + comp.companyId} type="star" className="bookmark actionIcon" />
                </Popover>
            </a>                

        let typology = <h4 className="companyTypology">{comp.companyTypology.text}</h4>

        let noteIcon = () => (
            <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 1024 1024" style={{ width: '1em', height: '1em', verticalAlign: 'middle', fill: 'currentColor', overflow: 'hidden' }}>
                <path d="M997.8,397l-92.5-92.5l-0.3-0.3c-12.3-12.1-32.2-12-44.4,0.2l-38.9,38.9V141.2C821.6,62.3,776.3,17,697.4,17H233.9
	                c-35.6,0-64.4,9.1-85.6,26.9c-18.8,15.9-30.9,38-35.9,65.8H48.5c-17.4,0-31.5,14.1-31.5,31.5c0,8.4,3.3,16.3,9.2,22.3
	                c6,6,13.9,9.2,22.3,9.2h61.2v122.3H48.5c-17.4,0-31.5,14.1-31.5,31.5c0,17.4,14.1,31.5,31.5,31.6h61.2v122.3H48.5
	                C31.1,480.5,17,494.6,17,512c0,8.4,3.3,16.3,9.2,22.3c6,6,13.9,9.2,22.3,9.2c0,0,0,0,0,0h61.2v122.3H48.5c-8.4,0-16.3,3.3-22.3,9.3
	                c-5.9,6-9.2,13.9-9.2,22.3c0,17.4,14.2,31.5,31.5,31.5c0,0,0,0,0,0h61.2v122.3H48.5c-8.4,0-16.3,3.3-22.3,9.3
	                c-5.9,6-9.2,13.9-9.2,22.3c0,17.4,14.2,31.5,31.5,31.5c0,0,0,0,0,0h63.8c5,27.8,17.1,49.9,35.9,65.8c21.2,17.9,50,26.9,85.6,26.9
	                h463.5c78.9,0,124.2-45.3,124.2-124.2v-265l176.2-176.2c5.9-6,9.2-13.9,9.2-22.3C1007,410.9,1003.7,403,997.8,397z M532.4,769.7
	                v-51.6l51.6,51.6H532.4z M697.4,943.9H233.9c-31.7,0-49.1-8.8-56.6-29.6H234c8.4,0,16.3-3.3,22.3-9.3c5.9-6,9.2-13.9,9.2-22.3
	                c0-17.4-14.2-31.5-31.5-31.5c0,0,0,0,0,0h-61.2V728.9h61.2c17.4,0,31.5-14.1,31.5-31.5c0-17.4-14.1-31.5-31.5-31.5h-61.2V543.5h61.2
	                c17.4,0,31.5-14.1,31.5-31.5c0-17.4-14.1-31.5-31.5-31.5h-61.2V358.2h61.2c17.4,0,31.5-14.1,31.5-31.5c0-8.4-3.3-16.3-9.2-22.3
	                s-13.9-9.2-22.3-9.2h-61.2V172.8h61.2c17.4,0,31.5-14.1,31.5-31.5c0-8.4-3.3-16.3-9.2-22.3c-6-6-13.9-9.2-22.3-9.2h-56.6
	                c7.5-20.8,24.9-29.6,56.6-29.6h463.5c44,0,61.2,17.1,61.2,61.2v265L489.8,674.9c-5.6,5.6-9,13-9.3,20.9l0,0.5v93.8
	                c0,17.4,14.1,31.5,31.5,31.5h93.2l3.2,0l0.5-0.3c6.4-0.9,12.4-3.7,17.2-8.1l0.9-0.9l131.6-131.6v201.9
	                C758.5,926.8,741.4,943.9,697.4,943.9z M838.2,512L614.8,735.4l-48.1-48.1l223.4-223.4L838.2,512z M930.9,419.3l-48.1,48.1
	                l-48.1-48.1l48.1-48.1L930.9,419.3z"/>
            </svg>
        )

        let notes = comp.notes != null && comp.notes !== '' ?
            <Popover content={comp.notes}>
                <Icon className="actionIcon noteIconHome" component={noteIcon} style={{ color: 'rgb(33, 58, 102)' }} />
            </Popover>
            :
            <Popover content="Notes" trigger="hover">
                <Icon className="actionIcon noteIconHome" component={noteIcon} />
            </Popover>

        let deletedComp = () => (
            <svg height="25px" viewBox="-6 1 511 511.99892" width="25px">
                <path d="m77.339844 106.769531c5.738281-2.351562 8.050781-9.472656 4.496094-14.804687-2.523438-3.855469-7.726563-5.574219-12.160157-3.683594-4.574219 1.90625-6.910156 6.703125-5.992187 11.199219 1.265625 6.234375 7.871094 9.699219 13.65625 7.289062zm0 0" />
                <path d="m458.371094 227.898438h-22.292969v-12.730469c0-14.855469-12.085937-26.945313-26.941406-26.945313-76.078125.316406-73.566407-.707031-79.628907.914063v-130.722657c0-77.742187-329.007812-78.027343-329.007812 0v259.816407 84.265625c0 55.550781 172.613281 73.277344 270.390625 45.757812v11.28125c0 28.925782 23.539063 52.464844 52.46875 52.464844h98.871094c28.929687 0 52.464843-23.539062 52.464843-52.464844v-154.929687c13.757813-3.703125 23.914063-16.277344 23.914063-31.1875v-5.28125c0-22.1875-18.050781-40.238281-40.238281-40.238281zm-128.828125-12.730469c0-3.8125 3.097656-6.910157 6.910156-6.910157h72.683594c3.808593 0 6.910156 3.101563 6.910156 6.910157v12.730469h-86.503906zm-81.199219 42.589843c-.632812 2.363282-1.054688 4.917969-1.230469 7.105469-55.886719 11.433594-135.492187 10.476563-188.347656-6.128906-26.410156-8.300781-38.230469-18.417969-38.230469-24.769531v-54.695313c10.328125 6.691407 23.144532 11.621094 34.835938 15.136719 73.660156 22.148438 203.332031 17.761719 254.101562-15.136719v48.628907c-18.480468.015624-51.871094-4.839844-61.128906 29.859374zm22.546875 46.855469v38.484375c-57.21875 17.871094-152.679687 18.578125-212.125-.097656-26.410156-8.300781-38.234375-18.417969-38.234375-24.769531v-54.695313c22.882812 14.867188 59.898438 22.273438 86.980469 25.582032 44.335937 5.429687 97.070312 4.597656 141.578125-4.207032 3.683594 9.640625 11.875 17.03125 21.800781 19.703125zm-212.125-270.96875c58.421875-18.355469 154.039063-18.359375 212.472656 0 26.410157 8.300781 38.234375 18.417969 38.234375 24.769531 0 6.347657-11.824218 16.46875-38.234375 24.765626-45.394531 14.265624-108.191406 16.421874-156.503906 11.070312-5.488281-.601562-10.449219 3.355469-11.0625 8.851562-.605469 5.5 3.359375 10.453126 8.855469 11.058594 55.550781 6.15625 152.023437 3.011719 196.945312-26.175781v61.714844c0 6.347656-11.824218 16.46875-38.234375 24.769531-58.421875 18.355469-154.039062 18.359375-212.472656 0-26.410156-8.300781-38.234375-18.421875-38.234375-24.769531v-61.722657c3.6875 2.40625 7.824219 4.632813 11.777344 6.488282 5.011718 2.347656 10.972656.191406 13.324218-4.816406 2.347657-5.007813.191407-10.972657-4.816406-13.320313-14.957031-7.015625-20.285156-13.855469-20.285156-17.914063 0-6.351562 11.824219-16.46875 38.234375-24.769531zm0 393.621094c-26.410156-8.300781-38.234375-18.421875-38.234375-24.769531v-54.695313c55.609375 36.132813 186.417969 34.222657 250.359375 16.191407v63.378906c-57.53125 17.96875-152.992187 18.472656-212.125-.105469zm395.894531 32.269531c0 17.882813-14.546875 32.429688-32.429687 32.429688h-98.875c-17.882813 0-32.429688-14.546875-32.429688-32.429688v-24.921875c0-.007812 0-.019531 0-.027343v-128.871094h163.734375zm23.914063-186.117187c0 6.761719-5.5 12.261719-12.261719 12.261719-10.601562 0-175.195312 0-185.402344 0-.703125-.117188-5.90625.800781-10.300781-3.59375-4.992187-4.996094-3.230469-10.851563-3.59375-13.949219 0-10.445313 7.964844-19.0625 18.136719-20.101563 1.90625-.191406.546875-.066406 33.828125-.101562h139.390625c11.140625 0 20.203125 9.0625 20.203125 20.203125zm0 0" />
                <path d="m372.792969 477.308594c5.53125 0 10.019531-4.484375 10.019531-10.015625v-136.90625c0-5.53125-4.488281-10.015625-10.019531-10.015625s-10.015625 4.484375-10.015625 10.015625v136.90625c0 5.53125 4.484375 10.015625 10.015625 10.015625zm0 0" />
                <path d="m324.40625 454.136719c5.535156 0 10.019531-4.488281 10.019531-10.019531v-90.554688c0-5.53125-4.484375-10.015625-10.019531-10.015625-5.53125 0-10.015625 4.484375-10.015625 10.015625v90.554688c0 5.53125 4.484375 10.019531 10.015625 10.019531zm0 0" />
                <path d="m421.179688 454.136719c5.53125 0 10.015624-4.488281 10.015624-10.019531v-90.554688c0-5.53125-4.484374-10.015625-10.015624-10.015625s-10.015626 4.484375-10.015626 10.015625v90.554688c0 5.53125 4.484376 10.019531 10.015626 10.019531zm0 0" /></svg>
        )

        let eye = comp.isDeleted && comp.status == 0 ?
            <div>
                <Popover content="Deleted" trigger="hover">
                    <Icon className="cardNotes" component={deletedComp} />
                </Popover>
                <Popover content="Hidden" trigger="hover">
                    <Icon style={{ right: '60px' }} className="cardNotes" type="eye-invisible" />
                </Popover>
            </div>
            : comp.isDeleted ?
                <Popover content="Deleted" trigger="hover">
                    <Icon className="cardNotes" component={deletedComp} />
                </Popover>
                : comp.status === 0 ?
                    <Popover content="Hidden" trigger="hover">
                        <Icon className="cardNotes" type="eye-invisible" />
                    </Popover>
                    : ""

        if (comp.companyParent != null) {
            var sorted_cat_par = comp.companyParent.brCompanyCategories.sort((a, b) => {
                return new Date(a.created).getTime() -
                    new Date(b.created).getTime()
            })
        }

        if (comp.companyDistributor != null) {
            var sorted_cat_dist = comp.companyDistributor.brCompanyCategories.sort((a, b) => {
                return new Date(a.created).getTime() -
                    new Date(b.created).getTime()
            })
        }

        if (comp.companyProducer != null) {
            var sorted_cat_prod = comp.companyProducer.brCompanyCategories.sort((a, b) => {
                return new Date(a.created).getTime() -
                    new Date(b.created).getTime()
            })
        }

        if (comp.companyLicenser != null) {
            var sorted_cat_lic = comp.companyLicenser.brCompanyCategories.sort((a, b) => {
                return new Date(a.created).getTime() -
                    new Date(b.created).getTime()
            })
        }

        let companyParentCat = comp.companyParent != null ? sorted_cat_par[0].companyCategories.companyCategoryParent != null ? sorted_cat_par[0].companyCategories.companyCategoryParent.name + ", " : "" : ""
        let ownedBy = comp.companyParent != null ? comp.companyTypologyTrValue == 1 ? <div style={{ width: '100%', textAlign: 'center' }}> <span>Società di: {sorted_cat_par[0].catId != sorted_cat[0].catId ? "(" + companyParentCat + sorted_cat_par[0].companyCategories.name + ") -" : ''} <span onClick={() => this.props.getDetail(comp.companyParentCompanyId, true)} className={comp.companyParent.status == 0 ? "hiddenLink" : "fakeLink"}>{comp.companyParent.name}</span></span></div > : <div style={{ width: '100%', textAlign: 'center' }}><span>Vedi: {sorted_cat_par[0].catId != sorted_cat[0].catId ? "(" + companyParentCat + sorted_cat_par[0].companyCategories.name + ") -" : ''} <span onClick={() => this.props.getDetail(comp.companyParentCompanyId, true)} className={comp.companyParent.status == 0 ? "hiddenLink" : "fakeLink"}>{comp.companyParent.name}</span></span></div> : ""
        let distributedBy = comp.companyDistributor != null ? <div style={{ width: '100%', textAlign: 'center' }}><span style={{ textAlign: 'center' }}>Vedi: {sorted_cat_dist[0].catId != sorted_cat[0].catId ? "(" + companyParentCat + sorted_cat_dist[0].companyCategories.name + ") -" : ''} <span className={comp.companyDistributor.status == 0 ? "hiddenLink" : "fakeLink"} onClick={() => this.props.getDetail(comp.companyDistributorCompanyId, true)}>{comp.companyDistributor.name}</span></span></div> : ""
        let producedBy = comp.companyProducer != null ? <div style={{ width: '100%', textAlign: 'center' }}><span style={{ textAlign: 'center' }}>Vedi: {sorted_cat_prod[0].catId != sorted_cat[0].catId ? "(" + companyParentCat + sorted_cat_prod[0].companyCategories.name + ") -" : ''} <span className={comp.companyProducer.status == 0 ? "hiddenLink" : "fakeLink"} onClick={() => this.props.getDetail(comp.companyProducerCompanyId, true)}>{comp.companyProducer.name}</span></span></div> : ""
        let licensedBy = comp.companyLicenser != null ? <div style={{ width: '100%', textAlign: 'center' }}><span style={{ textAlign: 'center' }}>Vedi: {sorted_cat_lic[0].catId != sorted_cat[0].catId ? "(" + companyParentCat + sorted_cat_lic[0].companyCategories.name + ") -" : ''} <span className={comp.companyLicenser.status == 0 ? "hiddenLink" : "fakeLink"} onClick={() => this.props.getDetail(comp.companyLicenserCompanyId, true)}>{comp.companyLicenser.name}</span></span></div> : ""

        let deleteComp = comp.isDeleted == 1 ?
            <Popconfirm title="Are you sure to delete this company, its sons and all of its components?" okText="Yes" cancelText="No" onConfirm={() => this.deleteComp(comp.companyId, 2)} >
                <Popover content="Delete" trigger="hover">
                    <Icon type="close" className="blueIcon" />
                </Popover>
            </Popconfirm>
            :
            <Popconfirm title="Are you sure to move this item to the bin?" okText="Yes" cancelText="No" onConfirm={() => this.deleteComp(comp.companyId, 1)} >
                <Popover content="Delete" trigger="hover">
                    <Icon type="delete" className="blueIcon" />
                </Popover>
            </Popconfirm>

        let lastUpdates = comp.lastUpdate ? comp.lastUpdate.slice(8, 10) + "/" + comp.lastUpdate.slice(5, 7) + "/" + comp.lastUpdate.slice(0, 4) + " (" + comp.lastUpdate.slice(11, 16) + ")" : null

        let createDate = comp.created ? comp.created.slice(8, 10) + "/" + comp.created.slice(5, 7) + "/" + comp.created.slice(0, 4) + " (" + comp.created.slice(11, 16) + ")" : null

        let metas =
            <div>
                <p><b>Created by:</b> {comp.userCreated}</p>
                <p><b>Created:</b> {createDate}</p>
                <hr />
                <p><b>Last updated by:</b> {comp.userUpdated}</p>
                <p><b>Last update:</b> {lastUpdates}</p>
            </div>

        let info =
            <Popover content={metas} title="Informations">
                <Icon style={{ padding: '5px 10px' }} type="info-circle" />
            </Popover>

        let revert = comp.isDeleted == 1 ?
            <Popconfirm title="Are you sure to restore this company?" okText="Yes" cancelText="No" onConfirm={this.revertComp} >
                <Popover content="Restore" trigger="hover">
                    <Icon className="blueIcon" type="rollback" />
                </Popover>
            </Popconfirm> :
            <Link to={"/edit?id=" + comp.companyId} >
                <Popover content="Edit" trigger="hover">
                    <Icon className="actionIcon" type="edit" className="blueIcon" />
                </Popover>
            </Link>

        let download =
            <Popover content="Download" trigger="hover">
                <Icon className="actionIcon" type="download" onClick={this.downloadImage} />
            </Popover>

        let actionsFooter = this.state.blockFooter ? [<div>{bookmark} {info} {download} </div>] : [<div> {revert} {deleteComp}</div>, <div>{bookmark} {notes} {info} {download} </div>]

        let cardDetail = comp.status === 1 || comp.status === 4 || comp.status === 5 || comp.status === 0 ?
            <Card actions={actionsFooter}>
                {immagine}
                {eye}                        
                {typology}
                {pIva}
                {description}
                {companyOwned}
                {brandOwnedFinal}
                {signOwnedFinal}
                {ProducedByOthersFinal}
                {brandCompanyProduced}
                {brandCompanyDistributed}
                {brandCompanyLicensed}
                {signCompanyProduced}
                {signCompanyDistributed}
                {signCompanyLicensed}
                {category}
                {ownedBy}
                {distributedBy}
                {producedBy}
                {licensedBy}
                {dadOrSon}
            </Card>
            :
            <Card actions={[<div>{revert} {deleteComp}</div>, <div>{bookmark} {notes} {info}</div> ]}>
                {immagine}
                {eye}
                {typology}
                {companyOwned}
                {ownedBy}
                {distributedBy}
                {producedBy}
                {licensedBy}
                {category}
                {dadOrSon}
            </Card>

        return (
            <div>
                {cardDetail}
            </div>
        )
    }

}

export default CardDetailed;


// WEBPACK FOOTER //
// ./src/util/compCardDetailed.js